// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  env_name: 'dev',
  AMAZON_S3_BUCKET_URL: 'https://evnavigation-dev.s3.eu-central-1.amazonaws.com',
  APPLE_CLIENT_ID: 'com.gpstuner.evnaviapp.client',
  APPLE_REDIRECT_URI: 'https://dev.evnavigation-api-v2.dev.gpstuner.net/oauth/token',
  TRACK_CLOSE_TIME_SECS: 10*60,
  TRACK_CLOSE_DISTANCE_METERS: 2000,
  API_URL: 'https://dev.evnavigation-api-v2.dev.gpstuner.net',
  BACKEND_URL: 'https://dev.engine.dev.gpstuner.net',
  REVERSE_GEOCODE_URL: 'https://dev.routing-gpstuner-com.dev.gpstuner.net',
  TILE_SERVER_URL: 'https://dev.tile-server.dev.gpstuner.net',
  MAP_ASSETS_URL: 'https://mapassets.gpstuner.net',
  RECAPTCHA_SITE_KEY: '6LePecYUAAAAALxWbq0rs8n5cE_VLgHz5TChWoyv',
  BUGSNAG_API_KEY : '81dff23ac6fa349382f1a4941443571d',
  GMAPS_API_KEY_WEB: 'AIzaSyDzoYdN55gJiYCPkBMHYTFzV_Rtgxwx6Ik',
  GMAPS_API_KEY_ANDROID: 'AIzaSyB4Hy2CcqYl_mUn8whlMdiSubwdqRJGeAo',
  GMAPS_API_KEY_IOS: ' AIzaSyAoLWah3GNuTCDdj1ejbEvsD-DnzdbMR-w',
  OPENAI_API_KEY: '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',
  STRIPE_PRO_MONTHLY_PRICE_ID_EUR: 'price_1TR6GAACPKkJHlLL09mKfiU6',
  STRIPE_PRO_MONTHLY_PRICE_ID_USD: 'price_1TR6LVACPKkJHlLLWbB1TCkR',
  STRIPE_PROPLUS_MONTHLY_PRICE_ID_EUR: 'price_1TR6PeACPKkJHlLLxVJY9FkO',
  STRIPE_PROPLUS_MONTHLY_PRICE_ID_USD: 'price_1TR6Q4ACPKkJHlLLDx9f10xa',
  STRIPE_PRO_YEARLY_PRICE_ID_EUR: 'price_1TR6MVACPKkJHlLLMYiStoei',
  STRIPE_PRO_YEARLY_PRICE_ID_USD: 'price_1TR6JyACPKkJHlLLvLJwyy51',
  STRIPE_PROPLUS_YEARLY_PRICE_ID_EUR: 'price_1TR6RKACPKkJHlLLtlUAaZaR',
  STRIPE_PROPLUS_YEARLY_PRICE_ID_USD: 'price_1TR6RdACPKkJHlLL2BKqS6ac',
  consolelog: true
};
